export enum HttpHeader {
  CONTENT_TYPE = 'Content-Type',
  AUTHORIZATION = 'Authorization',
  ACCEPT_LANGUAGE = 'accept-language'
}
